import styles from "./style.module.css";

const AddBusinessesInput = ({ className, ...props }) => {
  return <input className={[styles.input, className].join(" ")} {...props} />;
};

export default AddBusinessesInput;
